import * as React from 'react';
import SuperCritical from 'lib/supercritical';

import { UserSummary } from 'data/models/UserSummary';

export interface WithUser {
    User : () => UserSummary | null;
}

// TH 12/15/2016 -- Common links used by both AcceptInvitation and
// RestoreAccount pages.
export const ProfileAndLandingPageLinks = SuperCritical(({ model: m } : { model : WithUser }) =>
    <div>
        <div className="link-shell">
            <a href="#!mepage">View my profile</a>
        </div>
        <div className="link-shell">
            <a href={m.User() && m.User()!.LandingPage() || '#'}>View my landing page</a>
        </div>
    </div>
);

export const HomepageLink = SuperCritical(() =>
    <div className="link-shell">
        <a href="#">Back to homepage</a>
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/acceptinvitation/invitationlinks.tsx